var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9584,
    y: 1.9584,
    width: 114.083,
    height: 114.083,
    rx: 57.0416,
    fill: "#FFDDDC",
    stroke: "#FF0400",
    strokeWidth: 3.91681
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2941 35.7396C81.9775 35.4224 81.6014 35.1707 81.1875 34.9989C80.7735 34.8272 80.3297 34.7388 79.8815 34.7388C79.4333 34.7388 78.9895 34.8272 78.5755 34.9989C78.1615 35.1707 77.7855 35.4224 77.4689 35.7396L60.7346 52.4397L44.0003 35.7054C43.6835 35.3886 43.3074 35.1372 42.8934 34.9658C42.4795 34.7943 42.0358 34.7061 41.5877 34.7061C41.1397 34.7061 40.696 34.7943 40.282 34.9658C39.8681 35.1372 39.4919 35.3886 39.1751 35.7054C38.8583 36.0222 38.607 36.3983 38.4355 36.8123C38.264 37.2263 38.1758 37.6699 38.1758 38.118C38.1758 38.5661 38.264 39.0097 38.4355 39.4237C38.607 39.8377 38.8583 40.2138 39.1751 40.5306L55.9094 57.2649L39.1751 73.9991C38.8583 74.316 38.607 74.6921 38.4355 75.1061C38.264 75.52 38.1758 75.9637 38.1758 76.4118C38.1758 76.8598 38.264 77.3035 38.4355 77.7175C38.607 78.1314 38.8583 78.5075 39.1751 78.8244C39.4919 79.1412 39.8681 79.3925 40.282 79.564C40.696 79.7354 41.1397 79.8237 41.5877 79.8237C42.0358 79.8237 42.4795 79.7354 42.8934 79.564C43.3074 79.3925 43.6835 79.1412 44.0003 78.8244L60.7346 62.0901L77.4689 78.8244C77.7857 79.1412 78.1618 79.3925 78.5758 79.564C78.9897 79.7354 79.4334 79.8237 79.8815 79.8237C80.3295 79.8237 80.7732 79.7354 81.1872 79.564C81.6011 79.3925 81.9773 79.1412 82.2941 78.8244C82.6109 78.5075 82.8622 78.1314 83.0337 77.7175C83.2052 77.3035 83.2934 76.8598 83.2934 76.4118C83.2934 75.9637 83.2052 75.52 83.0337 75.1061C82.8622 74.6921 82.6109 74.316 82.2941 73.9991L65.5598 57.2649L82.2941 40.5306C83.5945 39.2302 83.5945 37.04 82.2941 35.7396Z",
    fill: "#FF0400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failedIcon.a796546a0d15b422009bb616bac2a598.svg";
export { ForwardRef as ReactComponent };